import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Download, FileText, FileSpreadsheet, Database } from 'lucide-react';
import { toast } from 'sonner';

export function ExportDropdown({ onExportCSV, onExportPDF, onExportSourceData }) {
  const handleCSV = () => { onExportCSV(); toast.success('CSV exported successfully'); };
  const handlePDF = () => { onExportPDF(); toast.success('PDF exported successfully'); };
  const handleSource = () => { onExportSourceData(); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="export-button">
          <Download className="w-4 h-4 mr-2" />
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleCSV} data-testid="export-csv-button">
          <FileSpreadsheet className="w-4 h-4 mr-2" />
          Export Summary (CSV)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handlePDF} data-testid="export-pdf-button">
          <FileText className="w-4 h-4 mr-2" />
          Export Report (PDF)
        </DropdownMenuItem>
        {onExportSourceData && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleSource} data-testid="export-source-data-button">
              <Database className="w-4 h-4 mr-2" />
              Export Source Data (CSV)
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
